"use strict";
/**
* Copyright: Microsoft 2016
*/
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
var logger_1 = require("../common/logger");
var LocalizationLoader = (function () {
    function LocalizationLoader() {
        var _this = this;
        this.initSync = function (settings) {
            var isDefault = settings.fallback === settings.locale;
            _this.fallbackStringTable = settings.fallbackTable;
            if (isDefault) {
                _this.localizedStringTable = _this.fallbackStringTable;
            }
            else {
                _this.localizedStringTable = settings.localizedTable;
            }
        };
        this.initAsync = function (providers, locale, fallback, override) {
            if (override === void 0) { override = false; }
            var promises = [];
            // Upon language switch, we should kill all the tables
            if (override) {
                _this.fallbackStringTable = {};
                _this.localizedStringTable = {};
            }
            var _loop_1 = function (provider) {
                var namespace = provider.getNamespace();
                if (fallback) {
                    var localeMatchesFallback_1 = (locale === fallback);
                    var fallbackPromise = provider
                        .getStringTable(fallback)
                        .then(function (table) {
                        // Add to fallback table, as this is a fallback promise.
                        _this.fallbackStringTable = _this._fillTable(table, _this.fallbackStringTable, true, namespace);
                        // If we are indeed just loading the fallback, add it to localized table too
                        if (localeMatchesFallback_1) {
                            _this.localizedStringTable = _this._fillTable(table, _this.localizedStringTable, true, namespace);
                        }
                    });
                    promises.push(fallbackPromise);
                    // Main language and fallback language are the same? No need for second request!
                    if (localeMatchesFallback_1) {
                        return "continue";
                    }
                }
                promises.push(provider
                    .getStringTable(locale)
                    .then(function (table) {
                    // We are loading main translation table on top of any fallback filled above
                    _this.localizedStringTable = _this._fillTable(table, _this.localizedStringTable, true, namespace);
                })
                    .catch(function () { return null; }));
            };
            for (var _i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
                var provider = providers_1[_i];
                _loop_1(provider);
            }
            return es6_promise_1.Promise.all(promises).then(function () { return; });
        };
    }
    LocalizationLoader.prototype._loadString = function (path, namespace) {
        var sections = path.split('.');
        var translationSection = this.localizedStringTable || this.fallbackStringTable;
        var fallbackTranslationSection = this.fallbackStringTable;
        //load eventual namespace
        if (namespace && translationSection[namespace]) {
            translationSection = translationSection[namespace];
        }
        //attempt to load also fallback namespace
        if (namespace && fallbackTranslationSection[namespace]) {
            fallbackTranslationSection = fallbackTranslationSection[namespace];
        }
        for (var i = 0; i < sections.length; i++) {
            var next = translationSection && translationSection[sections[i]];
            var nextFallbackBase = fallbackTranslationSection && fallbackTranslationSection[sections[i]];
            fallbackTranslationSection = nextFallbackBase;
            translationSection = next || nextFallbackBase;
            if (!translationSection) {
                return;
            }
        }
        return translationSection;
    };
    LocalizationLoader.prototype.hasString = function (path, namespace) {
        return !!this._loadString(path, namespace);
    };
    LocalizationLoader.prototype.getString = function (path, namespace) {
        var translation = this._loadString(path, namespace);
        if (!translation) {
            if (process && process.env && 'development' === process.env.NODE_ENV) {
                logger_1.logger.error('Translation key "' + path + '" not found.');
                return path;
            }
            return '';
        }
        return translation;
    };
    LocalizationLoader.prototype._fillTable = function (newKeys, existingKeys, append, namespace) {
        if (append) {
            if (namespace) {
                existingKeys[namespace] = __assign({}, newKeys, existingKeys[namespace]);
            }
            else {
                existingKeys = __assign({}, newKeys, existingKeys);
            }
        }
        else {
            if (namespace) {
                existingKeys[namespace] = newKeys;
            }
            else {
                existingKeys = newKeys;
            }
        }
        return existingKeys;
    };
    return LocalizationLoader;
}());
exports.LocalizationLoader = LocalizationLoader;
exports.localizationLoader = new LocalizationLoader();
